import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { message, Spin, Row, Divider, Tooltip, Icon, Button, Tag, Table, Input, Popconfirm } from 'antd';
import { PopUpForm } from '../../../lib/ui/popupform';
import Title from 'antd/lib/typography/Title';
import ErrorWrapper from '../../../lib/error_wrapper';
import { overrideHeaderTitle, overrideHeaderBack, NetworkDelaySearch, showErrorInNotification, formatMoney } from '../../../lib/util';
import { BasicHeader } from '../../../components/basic_header';
import { TransparentButton } from '../../../components/basic_items';
import { COLORS } from '../../theme';
import { Link } from 'react-router-dom';
import { StorageOutlined, FlipOutlined, WifiTetheringOutlined } from '@material-ui/icons';

const queryString = require('query-string');


const labels_cols = ({ onEditPressed,onDeletePressed }) => [
    {
        title: "Name",
        dataIndex: "label",
        key: "label"
    }, {
        title: "Actions",
        dataIndex: 'id',
        key: 'action',
        width: 100,
        render: (id, data) => {
            return <div style={{
                display:'flex',
                flexDirection:'row',
                justifyContent:'center',
                alignItems:'center'
            }}>
                <Button
                    type='link'
                    style={{ padding: 0 }}
                    onClick={() => {
                        typeof onEditPressed === 'function' && onEditPressed(id, data);
                    }}>Edit</Button>
                    <Divider type='vertical'/>
                    <Popconfirm 
                    title="Are you sure you want to delete this label?"
                    onConfirm={()=>{
                        typeof onDeletePressed==='function'&&onDeletePressed(id,data)
                    }}
                    arrowPointAtCenter placement='topRight'>
                    <Button
                    type='link'
                    style={{ padding: 0 ,color:COLORS.danger_primary}}
                    onClick={() => {
                    }}>Delete</Button>
                    </Popconfirm>
            </div>
        }
    }
];
class GroupLabels extends Component {
    constructor(props) {
        super(props)
        this.group_id = props.match.params.group_id;

        this.state = {
            form_data: {},
            edit_id: null,
            form_visibility: false,
            filter_query: {
                per_page: 100,
                page: 1
            },
            group_obj:{},
            loading:true
        }

        this.detail_group=RESTExecutor.detail().config({
            label:'detail'
        }).callbacks((success)=>{
            this.setState({ loading: false, group_obj: success.result })
            this.list_labels.config({
              params: {
                ...this.state.filter_query,
                group_id:this.group_id
              }
            }).execute();
        },(error)=>{
            this.setState({ loading: false })
        }).connect(props.domains.groups);

        this.list_labels = RESTExecutor.list().config({
            label: 'labelgroup_list',
            params: {
                ...this.state.filter_query
            }
        }).forId(this.group_id).connect(props.domains.groups);

        this.post_labels = RESTExecutor.post().config({
            label: 'labelgroup_list'
        }).callbacks((success) => {
            message.success("Label Added");
            this.setState({
                form_data: {},
                edit_id: null,
                form_visibility: false
            })
            this.list_labels.execute();
        }).connect(props.domains.groups);

        this.patch_labels = RESTExecutor.patch().config({
            label: 'labelgroup_detail',
            params: {}
        }).callbacks((success) => {
            message.success("Label Updated");
            this.setState({
                form_data: {},
                edit_id: null,
                form_visibility: false
            })
            this.list_labels.execute();
        }).connect(props.domains.groups);

        this.delete_labels = RESTExecutor.delete().config({
            label: 'labelgroup_detail',
            params: {}
        }).callbacks((success) => {
            message.success("Label Deleted");
            this.list_labels.execute();
        },(error)=>{
            showErrorInNotification(error)
        }).connect(props.domains.groups);

        // this.list_labels.execute();

        this.delay_search = new NetworkDelaySearch();


    }

    handlePostPatchFlag = (data) => {
        if (this.state.edit_id) {
            this.patch_labels.forId(this.state.edit_id).config({
            }).execute({...data,group_id:this.group_id});
        } else {
            this.post_labels.execute({...data,group_id:this.group_id});
        }
    }
    stateUpdater = ({
        stateKey,
        valueKey,
        value,
        appendObj = {},
        callback
    }) => {
        let newData = this.state[stateKey];
        this.has_changed = true;
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }
    render() {
        let list_labels_resp = this.list_labels.response();
        let detail_group_resp=this.detail_group.response()
        let delete_labels_resp=this.delete_labels.response();

        let rowsData = (list_labels_resp.result && list_labels_resp.result.rows) || [];
        let rowsMeta = list_labels_resp.meta || {};

        let post_labels_resp = this.post_labels.response();
        let patch_labels_resp = this.patch_labels.response();
        const { filter_query,loading,group_obj } = this.state;

        if(loading){
            return <center><Spin/></center>
        }
        return <div>
            <ErrorWrapper error={detail_group_resp}
                onReload={()=>{
                    this.setState({loading:true})
                    this.detail_group.forId(this.group_id).execute()
                }}
                >

            <BasicHeader  
            title={group_obj.name}
            titleType="Group"
            subtitle="Labels"
                    right={[
                        <TransparentButton
                            label="Add New"
                            className='cta-primary'
                            hint="Add New Label"
                            onClick={() => {
                                this.setState({
                                    edit_id: null,
                                    form_data: {},
                                    form_visibility: true
                                })
                            }}

                        />,
                        <Link to={`/settings/groups/${this.group_id}/datatype`} >
                        <TransparentButton
                            label="Datatypes"
                            icon={<StorageOutlined/>}
                            hint="View Datatypes"
                        />
                    </Link>,
                    <Link to={`/settings/groups/${this.group_id}/reconcilers`} >
                        <TransparentButton
                            label="Reconcilers"
                            icon={<FlipOutlined />}
                            hint="View Reconcilers"
                        />
                    </Link>,
                     <Link to={`/settings/groups/${this.group_id}/source`} >
                     <TransparentButton
                         label="Sources"
                         icon={<WifiTetheringOutlined />}
                         hint="View Sources"
                     />
                 </Link>
                    ]}

                />
<div className='filter-card'>
                    <div className='filter-card-top' style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        flexWrap: 'nowrap',

                    }}>
                         <Input.Search
                                    autoFocus
                                allowClear
                                    placeholder="Search For"
                                    style={{
                                    }}
                                    value={filter_query.query}
                                    onChange={(e) => {
                                        this.stateUpdater({
                                            stateKey: 'filter_query', valueKey: 'query', value: e.target.value, callback: () => {
                                                this.delay_search.onSearch(() => {
                                                    this.props.history.push({
                                                        // pathname:"users",
                                                        search:queryString.stringify({...this.state.filter_query,per_page:100,page:1})
                                                    })
                                                })
                                            }
                                        })
                                    }}/>

                        </div></div>
            <ErrorWrapper error={list_labels_resp} onReload={() => {
                this.group_id = this.props.match.params.group_id;
                this.list_labels.forId(this.group_id).execute();
            }}>
                <div className='default-card' style={{
                    padding: 0
                }}>
                    {/* <CustomHeader /> */}


                    <Table
                        className='main-table'
                        loading={list_labels_resp.fetching||delete_labels_resp.fetching}
                        size='small'
                        scroll={{ x: true }}
                        pagination={{
                            simple: false,
                            position: 'bottom',
                            onChange: (current, size) => {
                                this.props.history.push({
                                    // pathname:"users",
                                    search:queryString.stringify({...this.state.filter_query,per_page:size,page:current})
                                })
                            },
                            defaultCurrent: 1,
                            current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                            pageSize: (rowsMeta && rowsMeta.requested_count),
                            total: (rowsMeta && rowsMeta.total_count),
                            showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                        }} 
                        rowKey={(record) => record.id} columns={labels_cols({
                            onEditPressed: (id, data) => {
                                this.setState({
                                    edit_id: id,
                                    form_data: data,
                                    form_visibility: true
                                })

                            },
                            onDeletePressed:(id,data)=>{
                                this.delete_labels.forId(id).config({
                                    params:{
                                        group_id:this.group_id
                                    }
                                }).execute()
                            }

                        })} dataSource={rowsData} />


                </div>
            </ErrorWrapper>
            <PopUpForm
                title="Label"
                forCreate={this.state.edit_id
                    ? false
                    : true}
                initialData={this.state.form_data}
                fields={[{ index: 'label', name: "Label Name", type: 'text', required: true }]}
                open={this.state.form_visibility}
                networkState={this.state.edit_id
                    ? patch_labels_resp
                    : post_labels_resp}
                onClose={() => {
                    this.setState({ form_visibility: false, form_data: {}, edit_id: null })
                }}
                onSubmit={(data) => {
                    this.handlePostPatchFlag(data);
                }} />

        </ErrorWrapper>
        </div>
    }

    componentDidMount() {
        overrideHeaderTitle("Labels List");
        overrideHeaderBack('back')
        let new_filter_query={};
        if(this.props.location&&this.props.location.search){
        const parsed = queryString.parse(this.props.location.search);
        new_filter_query=parsed;
        }
        this.setState({
        filter_query:{
            per_page:100,
            page:1,
            ...new_filter_query
        }
        },()=>{
            this.detail_group.forId(this.group_id).execute()
        })

    }
    componentWillUnmount() {
        overrideHeaderBack(null)
    }
    componentWillReceiveProps(nextProps) {
        var oldgroup_id = this.props.match.params.group_id;
        var newgroup_id = nextProps.match.params.group_id;
    
    
        if (oldgroup_id !== newgroup_id || (
          this.props.location && (this.props.location.search !== nextProps.location.search)
        )) {
          this.group_id = newgroup_id;
          const parsed = queryString.parse(nextProps.location.search);
          this.setState({
            filter_query: {
              per_page: 100,
              page: 1,
              ...parsed,
              group_id:this.group_id
            },
          }, () => {
            if (oldgroup_id !== newgroup_id) {
              this.setState({
                loading: true
              }, () => {
                this.detail_group.forId(this.group_id).execute()
              })
            } else {
              this.list_labels.forId(this.group_id).config({
                params: {
                  ...this.state.filter_query,
                }
              }).execute()
            }
          })
    
        }
      }

}

export default withDomains(GroupLabels, "groups");
